@use '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils' as typography;
@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.wrapper {
  display: flex;
  align-items: flex-start;
  margin-top:  hevo-toolkit-variables.$spacer;
}

.wrapper:first-child {
  margin-top: 0;
}

.rdDetails {
  flex: 1;
}

.rdEntities {
  margin-top:  hevo-toolkit-variables.$spacer * 0.25;
  @include typography.typography-level-to-styles(typography.typography-config(), body-2);
}

.rdCaption {
  color:  hevo-toolkit-variables.$text-secondary;
  @include typography.typography-level-to-styles(typography.typography-config(), caption-1);
}
